import type { PieArcDatum, ProvidedProps } from '@visx/shape/lib/shapes/Pie';

import type { PiePartitionConfig } from '@blockworks/platform/api/research/studio';

import type { PieOptions } from './use-pie-options';

type GetArcDataArgs = {
    pie: ProvidedProps<PiePartitionConfig>;
    arc: PieArcDatum<PiePartitionConfig>;
    partitions?: PiePartitionConfig[];
    aggregrate: number;
    isDonut: boolean;
    radius: PieOptions['radius'];
};

const getIsSmallSlice = (arcValue: number, aggregrate: number, isDonut: boolean, radius: PieOptions['radius']) => {
    const circumference = (2 * Math.PI * (radius.inner + radius.outer)) / 2;
    const arcWidth = (arcValue / aggregrate) * circumference;

    return arcWidth < (isDonut ? 40 : 45);
};

const getArcOptions = ({ pie, arc, partitions, aggregrate, isDonut, radius }: GetArcDataArgs) => {
    const { value, data } = arc;

    const color = data?.color || `hsl(${((arc.index || 1) * 360) / (partitions?.length || 1)}, 70%, 50%)`;
    const [centroidX, centroidY] = pie.path.centroid(arc);
    const percentage = value && aggregrate ? ((value / aggregrate) * 100).toFixed(1) : '';

    const isSmallSlice = getIsSmallSlice(value, aggregrate, isDonut, radius);

    return {
        centroidX,
        centroidY,
        percentage,
        isSmallSlice,
        ...data,
        value,
        color,
    };
};

export { getArcOptions };
